import React from 'react'
import { withTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';

import './FormBox.scss'

export default withTranslation()(function FormBox({t, header, header2, children}) {

    return (
        <Box className="formWrapper">
            {
                header &&
                <Box className="formHeader">
                    {t(header)}
                </Box>
            }
            {
                header2 &&
                <Box className="formHeader danger bold">
                    {t(header2)}
                </Box>
            }
            {children}
        </Box>
    )
})
